<template>
    <div class="show-more-locked">
        <UncrawlableLink v-slot="{navigate}" custom external :to="href ?? ''">
            <VJoyButton
                icon="lock"
                :label="label"
                :data-testid="testId"
                variant="ghost"
                :size="size ?? 'medium'"
                @click="onClick(navigate, $event)"
            />
        </UncrawlableLink>
    </div>
</template>

<script setup lang="ts">
    import {UncrawlableLink} from '#components';
    import {VJoyButton, type TJoyButtonSizes} from '@maltjoy/core-vue';

    const {href} = defineProps<{
        label: string;
        testId: string;
        href?: string;
        size?: TJoyButtonSizes;
    }>();

    const emits = defineEmits<{
        click: [];
    }>();

    function onClick(navigate: (event?: MouseEvent) => Promise<void>, event: MouseEvent) {
        emits('click');
        if (href) {
            void navigate(event);
        }
    }
</script>
<style lang="scss" scoped>
    .show-more-locked {
        display: flex;
        justify-content: center;

        :deep(.joy-button--slot) {
            white-space: wrap;
        }
    }
</style>
